// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"e47b24de","227":"fe5ad86d","279":"09615a61","287":"089cc90d","367":"1e52e05c","555":"a9eed463","570":"abcf89ec","666":"0c9cf703","843":"953739eb"}[chunkId] + ".chunk.js";
};